import { ResourcesConfig } from 'aws-amplify';


export const cognitoAuthConfig: ResourcesConfig = {
    Auth: {
      Cognito: {
        userPoolClientId: '1v0pa9p4mekb2o9vobpv4keuuj',
        userPoolId: 'us-west-2_0ANvwBa87',
      },
    },
};
